//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { CustomFieldDisplayItem } from './CustomFieldDisplayItem';
import { ICustomFieldWithHint } from './ICustomFieldWithHint';
import { ICustomFieldWithRequired } from './ICustomFieldWithRequired';
import { ICustomFieldWithOptions } from './ICustomFieldWithOptions';
import { CustomFieldType } from './Enums';

export class CustomFieldDropDownListDisplayItem extends CustomFieldDisplayItem implements ICustomFieldWithHint, ICustomFieldWithRequired, ICustomFieldWithOptions {
    Hint: string | null = null;
    Required: boolean = false;
    Options: string[] = [];
    override readonly FieldType: CustomFieldType = CustomFieldType.DropDownList;

    constructor(initializer?: Partial<Omit<CustomFieldDropDownListDisplayItem, "FieldType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "CustomFieldDropDownListDisplayItem";
}
